import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            variableName=''
        } = executionObject;

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });
    
        let resolvedParams = parsedParameters['accumulator'];
        let siteKey = resolvedParams.recaptchaSiteKey;
        
        if(
            !siteKey ||
            typeof siteKey !== 'string'
        ){
            console.log('Invalid recaptcha site key');
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Invalid recaptcha site key.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }
        
        let variableCopy = parsedParameters['variableObject'];
        let scriptId = 'recaptcha-v3-script';

        if (!document.getElementById(scriptId)) {
            await new Promise((resolve, reject) => {
                let script = document.createElement('script');
                script.id = scriptId;
                script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
                script.async = true;
                script.onload = resolve;  // Resolve when script loads
                script.onerror = reject;  // Reject on error
                document.body.appendChild(script);
            });
        }

        //initialize recaptcha v3
        await new Promise((resolve) => {
            window.grecaptcha.ready(resolve);
        });

        variableCopy[variableName] = {
            message : 'reCAPTCHA v3 initialized successfully.',
            success : true
        };

        return {
            hasError : false,
            errorPayload : undefined,
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/initializeRecaptchaV3Parser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}